import { render, staticRenderFns } from "./PredictionControl.vue?vue&type=template&id=228577bc&scoped=true&"
import script from "./PredictionControl.vue?vue&type=script&lang=js&"
export * from "./PredictionControl.vue?vue&type=script&lang=js&"
import style0 from "./PredictionControl.vue?vue&type=style&index=0&id=228577bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228577bc",
  null
  
)

export default component.exports